module.exports = __webpack_public_path__ + "img/r3.e57d99dc.jpeg";